import { render, staticRenderFns } from "./ClassesThumbnail.vue?vue&type=template&id=f6ea7a42&scoped=true"
import script from "./ClassesThumbnail.vue?vue&type=script&lang=js"
export * from "./ClassesThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ClassesThumbnail.vue?vue&type=style&index=0&id=f6ea7a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ea7a42",
  null
  
)

export default component.exports